import { Component, Input } from '@angular/core';

/**
 * Fallback field message for controls that do not expose DS `hint`
 * (checkbox, radio group, section-level validation).
 */
@Component({
  standalone: false,
  selector: 'app-field-message',
  template: `
    <p
      *ngIf="show"
      class="app-field-message"
      [class.app-field-message--error]="status === 'error'"
      [class.app-field-message--success]="status === 'success'"
      role="status">
      <ng-content></ng-content>
    </p>
  `,
  styles: [`
    .app-field-message {
      margin: 4px 0 0;
      font-family: var(--font-family);
      font-size: 12px;
      line-height: 1.4;
      color: #4b5563;
    }
    .app-field-message--error {
      color: #b42318;
    }
    .app-field-message--success {
      color: #027a48;
    }
  `],
})
export class FieldMessageComponent {
  @Input() show = false;
  @Input() status: 'error' | 'success' | 'help' = 'error';
}
